import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeNestedDataSource } from '@angular/material/tree';
import { Router } from '@angular/router';
import {
	AuthloginService,
	ChatMessage,
	CurrentService,
	ProjectService,
	RouteElementService,
	ElementsService
} from 'dbweb-core';
import { Observable, Subscription } from 'rxjs';
import { portraitDefault } from '../../const';
import { MainNavService } from '../../services/main-nav.service';
import { TabsService } from '../tabs.service';
import { NavItem } from './nav-item';
import { NavtreeService, NavHome } from './navtree.service';

export class FileFlatNode {
	constructor(public expandable: boolean, public filename: string, public level: number, public type: any) {}
}
@Component({
	selector: 'common-home-nav',
	templateUrl: './home-nav.component.html',
	styleUrls: ['./home-nav.component.scss'],
	providers: [NavtreeService, NavHome]
})
export class HomeNavComponent implements OnInit, OnDestroy {
	@ViewChild('dialogScroll', { static: false })
	dialogScroll: ElementRef<HTMLDivElement>;
	@ViewChild('maxNavContainer', { static: false })
	maxNavContainer: ElementRef<HTMLDivElement>;
	@ViewChild('minNavContainer', { static: false })
	minNavContainer: ElementRef<HTMLDivElement>;
	// æ¯æ­£å¸¸å¯¼èªè¿æ¯ç®ç¥å¯¼èª
	isMinNav = true;
	// æ¯å¦æå¼å¯¹è¯æ¡
	isOpenDialog = false;

	nestedTreeControl: NestedTreeControl<NavItem>;
	nestedDataSource: MatTreeNestedDataSource<NavItem>;
	treeControl: FlatTreeControl<FileFlatNode>;
	treeFlattener: MatTreeFlattener<NavItem, FileFlatNode>;
	dataSource: MatTreeFlatDataSource<NavItem, FileFlatNode>;
	currentNode: NavItem;
	navItems: NavItem[] = [];
	chatObservable: Observable<ChatMessage>;
	constructor(
		public nav: NavHome,
		public current: CurrentService,
		public eles: ElementsService,
		public database: NavtreeService,
		private auth: AuthloginService,
		private routeEle: RouteElementService,
		public prj: ProjectService,
		public navMain: MainNavService,
		private router: Router,
		private tabs: TabsService
	) {
		this.isMinNav = this.navMain.getCurrent();
		this.navMain.navMin.subscribe(v => {
			this.switchNavToMin(v);
		});
		this.current.change$.subscribe(v => {
			if (v && v.HeadPortrait) {
				this.nav.portraitURL = v.portraitURL;
			} else {
				this.nav.portraitURL = portraitDefault;
			}
		});
	}
	switchNavToMin(v: boolean) {
		if (v === this.isMinNav) {
			return;
		}
		setTimeout(() => {
			this.isMinNav = v;
		}, 300);
		if (v) {
			this.maxNavContainer.nativeElement.style.width = '80px';
			this.maxNavContainer.nativeElement.style.transition = 'all 0.3s';
		} else {
			this.minNavContainer.nativeElement.style.width = '240px';
			this.minNavContainer.nativeElement.style.transition = 'all 0.3s';
		}
	}
	ngOnInit() {
		this.nestedTreeControl = new NestedTreeControl<NavItem>(this._getChildren);
		this.nestedDataSource = new MatTreeNestedDataSource();
		this.nestedDataSource.data = this.database.root.children;
		// this.buttonHight();
		this.navItems = this.nestedDataSource.data;
		this.nav.subs.push(
			this.routeEle.currentElementListen.subscribe(e => {
				// å¶å°ä¼åºç°eæªnullçæåµï¼åå æªæ¢æ¥ï¼ç­ææ¶é´åæ¹é 
				if (e && e.element) {
					this.currentNode = null;
					this.obtainNode(e.element.Name, this.navItems);
					if (this.nav.activeNode.length !== 0 && this.currentNode !== null) {
						this.nav.activeNode.splice(0, this.nav.activeNode.length);
					}
					if (this.nav.openNodeCurrent.length !== 0 && this.currentNode !== null) {
						this.nav.openNodeCurrent.splice(0, this.nav.openNodeCurrent.length);
					}
					if (this.currentNode !== null) {
						this.nav.recursionFuns(this.currentNode);
						this.nav.recursionFun(this.currentNode);
					}
				}
			})
		);
		this.nav.messages();
	}
	ngOnDestroy(): void {
		this.nav.subs.forEach(v => v.unsubscribe());
	}
	logout() {
		this.router
			.navigateByUrl('/login' + '/' + this.prj.apiNav()[0] + '/' + this.prj.apiNav()[1] + '/login')
			.then(() => {
				// å¿é¡»è¦å¨è·¯ç±åæ¢ä¹åï¼å ä¸ºåªæåæ¢åï¼æä¼å¨reuseä¸­å­å¨ï¼æè½clear
				this.tabs.clear(); // ä¸å®è¦åæ¸é¤ææçtabé¡µé¢ï¼ç¨äºåæ¶è®¢écurrçåå
				this.auth.logoutDefault().subscribe();
			});
	}
	hasNestedChild(_: number, nodeData: NavItem) {
		return !!nodeData.children && nodeData.children.length > 0;
	}
	_getChildren = (node: NavItem) => node.children;
	// å¯¹è¯æ¡æ¾ç¤º
	openDialog() {
		this.isOpenDialog = true;
		// this.unread = null;
		setTimeout(() => {
			this.dialogScrolls();
		}, 0);
	}
	closeDialog() {
		this.isOpenDialog = false;
	}

	// è·åå½åèç¹çnode
	obtainNode(title: string, navItems: NavItem[]) {
		for (let i = 0; i <= navItems.length - 1; i++) {
			if (navItems[i].name === title) {
				this.currentNode = navItems[i];
			}
			if (navItems[i].children !== undefined && this.currentNode == null) {
				this.obtainNode(title, navItems[i].children);
			}
		}
	}

	sendMessage() {
		if (this.nav.messageBody) {
			this.current.wsChat.next({
				Creator: this.prj.Creator(),
				Project: this.prj.Name(),
				From: this.current.data.UserName,
				Addr: '',
				Time: null,
				Data: this.nav.messageBody
			});
			this.nav.messageBody = '';
		}
		setTimeout(() => {
			this.dialogScrolls();
		}, 0);
	}
	// è¾å¥æ¡çåè½¦äºä»¶
	keyDown(e: any) {
		const ev = window.event || e;

		// 13æ¯é®çä¸é¢åºå®çåè½¦é®
		if (ev.keyCode === 13) {
			// ä½ è¦æ§è¡çæ¹æ³
			this.sendMessage();
		}
	}
	// å°èå¤©çªå£æ»å¨æ¡æ»è³æä¸æ¹
	dialogScrolls() {
		if (this.dialogScroll == null) {
			return;
		}
		this.nav.unread = null;
		this.dialogScroll.nativeElement.scrollTop = this.dialogScroll.nativeElement.scrollHeight;
	}

	// å¤æ­æ¯å¦å·²éè¯»ææ°æ¶æ¯
	isNews() {
		const isScrolledToBottom =
			this.dialogScroll.nativeElement.scrollHeight - this.dialogScroll.nativeElement.clientHeight <=
			this.dialogScroll.nativeElement.scrollTop + 1;
		if (isScrolledToBottom) {
			this.nav.unread = null;
		}
	}
}
